module.exports = __webpack_public_path__ + "static/media/taste-test-iphone-2.ae00a929.png";